export default "__VITE_ASSET__CJyW3WEP__"